<template>
  <div class="container" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="top">
      <h1>{{data.headtitle}}</h1>
      <a @click="reset" v-if="data.past_days>=90">重新测试</a>
      <a v-else class="disabled">{{90-data.past_days}} 天后可重测</a>
      <div class="person">
        <span class="head"><img :src="data.headimgurl"></span>
        <h2>{{data.nickname}}</h2>
        <h3 style="width: 100%;">{{data.ctime}}</h3>
      </div>
    </div>
    <div class="p2">
      <div class="table">
        <div class="tr">
          <div class="th"></div>
          <div class="th">得分</div>
          <div class="th">满分</div>
        </div>
        <div class="tr" v-for="item in data.result.score">
          <div class="td">{{item.division}}</div>
          <div class="td">{{item.normalized}}</div>
          <div class="td">100</div>
        </div>
      </div class="table">
    </div>
    <div class="p3"></div>
    <!-- begin 插入广告组件 -->
    <!-- <public-advertising class="pdt"></public-advertising> -->
    <!--  -->
    <!-- <p class="copynig">*本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。</p> -->
    <!-- 关注二维码 -->
    <!-- <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p style="line-height: initial;">长按识别关注公众号<br/>回复“<font color="#f57f17">&nbsp;职业&nbsp;</font>”领取报告</p>
        <div class="text-center">
          <img class="qr-box" :src="data.qrcode" alt="" />
        </div>
      </div>
    </van-popup> -->
  </div>
</template>
<script>
import { ceping83_report, ceping83_reset} from "@/api/measurement";
import { shareCon} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import PublicAdvertising from "@c/measurement/public-advertising";
import { Dialog} from 'vant';

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        }
      }
    },
    components: {
      PublicAdvertising,
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      reset() {
        Dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping83_reset()
            .then((data) => {
              this.$router.push("/ceping83")
            })
        }).catch(() => {
          // on cancel
        });
      },
      pullData() {
        ceping83_report()
          .then((data) => {
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.data = data;
              
              this.qrcode = data.qrcode;
              if (this.data.need_subscribe && !this.data.subscribe) {
                this.isShow = true;
              };
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping83", this, this.type_obj);
            } else {
              // 已经测评完成
              this.$router.push('/ceping83')
            }

          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";

.container {
  width: 100%;
  // height: 1601px;
  background: url(../../../assets/ceping83/ceping83_report.png) no-repeat top center;
  background-size: 100%;
  background-color: #ffecd3;
  padding-bottom: 68px;
}

.top {
  padding-top: 60px;
  min-height: 380px;

  h1 {
    margin-left: 40px;
    font-size: 74px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 103px;
  }

  a {
    margin-left: 40px;
    margin-top: 10px;
    text-align: center;
    display: inline-block;
    width: auto;
    padding: 0 36px;
    height: 48px;
    line-height: 48px;
    background: #FFD4BD;
    border-radius: 27px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF5200;
  }

  a.disabled {
    background: #ccc;
    color: #fff;
  }

  .person {
    position: relative;
    padding-left: 112px;
    margin-top: 67px;

    .head {
      position: absolute;
      top: 0;
      left: 30px;
      width: 72px;
      height: 72px;
    }

    .head img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 1PX solid #fff;/*no*/
      box-sizing: border-box;
    }
  }

  h2 {
    width: 84px;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
  }

  h3 {
    width: 217px;
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
  }
}

.p2 {
  width: 100%;
  height: 634px;
  background: url(../../../assets/ceping83/ceping83_report_p2.png) no-repeat top center;
  background-size: 100%;
  padding-top: 107px;

  .table {
    display: table;
    width: 610px;
    text-align: center;
    // border-collapse: collapse;
    table-layout: fixed;
    margin: 0 auto;

    .tr {
      display: table-row;

      .th {
        display: table-cell;
        height: 80px;
        line-height: 80px;
        border: 1PX solid #FFDDBF;/*no*/
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F57F16;
        background: #FFF5EC;
        &:not(:last-child) {
          border-right: 0;
        }
      }

      .td {
        display: table-cell;
        height: 80px;
        line-height: 80px;
        border: 1PX solid #FFDDBF;/*no*/
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #747474;
        &:not(:last-child) {
          border-right: 0;
        }
      }

      .td:first-child {
        color: #F57F16;
      }

      .th:first-child {
        border-top-left-radius: 20px;
      }

      .th:last-child {
        border-top-right-radius: 20px;
      }

      &:not(:last-child) {
        .td, .th {
          border-bottom: 0;
        }
      }
    }
  }
}

.p3 {
  width: 100%;
  height: 520px;
  background: url(../../../assets/ceping83/ceping83_report_p3.png) no-repeat top center;
  background-size: 100%;
}

.radius {
  border-radius: 10px;
}

.copynig{
  font-size: 24px;
  color: #999999;
  padding: 50px 32px 60px;
}
</style>
